import { Link } from "react-router-dom";
import { useSite } from "../../lib/useSite";
import { Reveal, Eyebrow, InsuranceBadges } from "../../components/bits";
import { Check, ArrowRight } from "lucide-react";

function Hero({ eyebrow, title, sub }) {
  return (
    <section className="bg-[#0a0a0a] relative">
      <div className="absolute inset-0 noise-overlay" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-16">
        <Eyebrow dark>{eyebrow}</Eyebrow>
        <h1 className="font-display text-[#fdfbf7] text-5xl sm:text-6xl tracking-tight max-w-3xl leading-[1.05]">{title}</h1>
        {sub && <p className="text-[#cfcabf] mt-5 max-w-2xl">{sub}</p>}
      </div>
    </section>
  );
}

export default function Services() {
  const site = useSite();
  const services = site?.services || [];
  return (
    <div>
      <Hero eyebrow="Our Services" title="Cleaning services, tailored to you"
        sub="From regular domestic care to specialist deep and end-of-tenancy cleaning — every service is delivered to diamond standards." />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={(i % 3) * 0.05}>
            <div className="card-luxe p-7 h-full flex flex-col" data-testid={`service-card-${i}`}>
              <div className="flex items-center justify-between">
                <h3 className="font-display text-2xl tracking-tight">{s.name}</h3>
                {s.instant_booking && <span className="text-[10px] tracking-widest text-[#b5952f] border border-[#d4af37]/40 px-2 py-0.5 rounded-sm">INSTANT</span>}
              </div>
              <p className="text-[#555] text-sm mt-3 leading-relaxed flex-1">{s.description}</p>
              <div className="mt-5 space-y-1.5 text-sm">
                {s.starting_price > 0 && <p><span className="text-[#8a8a8a]">From</span> <span className="font-semibold">£{s.starting_price}/hr</span></p>}
                {s.min_hours > 0 && <p className="text-[#8a8a8a]">Minimum {s.min_hours} hours</p>}
                <p className="text-[#8a8a8a]">Est. duration: {s.duration}</p>
              </div>
              {s.manual_quote && <p className="text-xs text-[#b5952f] mt-3">Manual quotation recommended</p>}
              <Link to="/quote" className="inline-flex items-center gap-2 text-sm text-[#0a0a0a] font-semibold mt-5 group">
                Get a quote <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </Reveal>
        ))}
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-20">
        <div className="card-luxe p-8">
          <Eyebrow>Add-ons</Eyebrow>
          <h3 className="font-display text-3xl tracking-tight">Enhance any clean</h3>
          <div className="flex flex-wrap gap-3 mt-5">
            {["Inside oven", "Interior windows", "Fridge / freezer", "Ironing", "Balcony", "Inside cupboards"].map((a) => (
              <span key={a} className="flex items-center gap-2 text-sm border border-[#e0ddd4] px-3 py-1.5 rounded-sm"><Check size={14} className="text-[#d4af37]" /> {a}</span>
            ))}
          </div>
          <InsuranceBadges site={site} />
        </div>
      </section>
    </div>
  );
}
